// extracted by mini-css-extract-plugin
export default {"description":"GktgQq","saleEnds":"idSrhw"};